import React, { useEffect, useMemo, useState } from "react";
import "./TrendingNowWidget.css";

const DEMO = [
  "#Plague",
  "#Tuberculosis",
  "#Pandemic",
  "#Epidemic",
  "#DiseaseX",
  "#PublicHealth",
  "#AMR",
  "#Outbreak",
  "#GlobalHealth",
  "#Surveillance",

  "#NuclearAccident",
  "#RadiationLeak",
  "#RadiologicalIncident",
  "#ChemicalThreats",
  "#CBRN",
  "#BioThreat",
  "#Hazmat",

  "#NaturalDisaster",
  "#Earthquake",
  "#Floods",
  "#Wildfires",
  "#Heatwave",
  "#StormAlert",

  "#EmergencyResponse",
  "#CrisisManagement",
  "#SupplyChainRisk",
];

function normalizeTag(t) {
  const s = String(t || "").trim();
  if (!s) return "";
  // κρατάμε # και αφαιρούμε κενά
  const noSpaces = s.replace(/\s+/g, "");
  return noSpaces.startsWith("#") ? noSpaces : `#${noSpaces}`;
}

function xSearchUrl(query) {
  const q = encodeURIComponent(query);
  return `https://x.com/search?q=${q}&src=typed_query`;
}

export default function TrendingNowWidget() {
  const [items, setItems] = useState(DEMO);
  const [updatedAt, setUpdatedAt] = useState(Date.now());
  const [nowTick, setNowTick] = useState(0);

  const [search, setSearch] = useState("");

  function loadTrends() {
    setItems((prev) => {
      const copy = [...prev];
      copy.sort(() => Math.random() - 0.5);
      return copy;
    });
    setUpdatedAt(Date.now());
  }

  useEffect(() => {
    loadTrends();
    const t = setInterval(loadTrends, 90 * 1000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const t = setInterval(() => setNowTick((x) => x + 1), 60 * 1000);
    return () => clearInterval(t);
  }, []);

  const clean = useMemo(() => items.map(normalizeTag).filter(Boolean), [items]);

  // ✅ Αν τα items είναι λίγα και το viewport μεγάλο, δημιουργείται “κενό”.
  // Επαναλαμβάνουμε μέχρι να φτάσουμε ένα ασφαλές πλήθος.
  const loopList = useMemo(() => {
    if (clean.length === 0) return [];
    const MIN = 30; // αύξησε/μείωσε αν θες
    const out = [];
    while (out.length < MIN) out.push(...clean);
    return out;
  }, [clean]);

  const minutesAgo = useMemo(() => {
    const diff = Date.now() - updatedAt;
    return Math.max(0, Math.floor(diff / (60 * 1000)));
  }, [updatedAt, nowTick]);

  const onSubmitSearch = (e) => {
    e.preventDefault();
    const q = String(search || "").trim();
    if (!q) return;
    window.open(xSearchUrl(q.startsWith("#") ? q : `#${q.replace(/\s+/g, "")}`), "_blank", "noopener,noreferrer");
  };

  return (
    <div className="tnw">
      <div className="tnw-top">
        <div className="tnw-title">Trending now</div>
        <div className="tnw-sub">
          Updated {minutesAgo === 0 ? "just now" : `${minutesAgo}m ago`}
        </div>
      </div>

      <form className="tnw-search" onSubmit={onSubmitSearch}>
        <input
          className="tnw-input"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="#Search..."
          aria-label="Search hashtag"
        />
        <button className="tnw-btn" type="submit">
          Search
        </button>
      </form>

      <div className="tnw-viewport" aria-label="Trending hashtags">
        <div className="tnw-track">
          {loopList.length === 0 ? (
            <div className="tnw-footnote">No trending hashtags yet.</div>
          ) : (
            <>
              <div className="tnw-stack">
                {loopList.map((tag, i) => (
                  <a
                    key={`a-${tag}-${i}`}
                    className="tnw-item"
                    href={xSearchUrl(tag)}
                    target="_blank"
                    rel="noreferrer"
                    title={`Open ${tag} on X`}
                  >
                    {tag}
                  </a>
                ))}
              </div>

              {/* clone για seamless loop */}
              <div className="tnw-stack" aria-hidden="true">
                {loopList.map((tag, i) => (
                  <a
                    key={`b-${tag}-${i}`}
                    className="tnw-item"
                    href={xSearchUrl(tag)}
                    target="_blank"
                    rel="noreferrer"
                    tabIndex={-1}
                    title={`Open ${tag} on X`}
                  >
                    {tag}
                  </a>
                ))}
              </div>
            </>
          )}
        </div>
      </div>

      <div className="tnw-footnote">Hover to pause • Click to open hashtag in X</div>
    </div>
  );
}